<template>
	<AssessmentCharacteristics class="driven-characteristics"
		:is-skeleton="isSkeleton"
		:high-type="highType"
		:characteristics="characteristics"
	>
		<template #icon>
			<FontAwesomeIcon
				:icon="[ `far`, `bolt-lightning` ]"
			/>
		</template>
		<template #heading>{{ $t( "common.DrivenCharacteristics__heading" ) }}</template>
	</AssessmentCharacteristics>
</template>

<script>
import CommonCharacteristics from "./CommonCharacteristicsProps";
import AssessmentCharacteristics from "./AssessmentCharacteristics";
export default {
	name: "DrivenCharacteristics",
	mixins: [ CommonCharacteristics, ],
	components: {
		AssessmentCharacteristics,
	},
	computed: {
		characteristics() {
			const drivenBy = this.assessment?.teamingContent?.drivenBy || "";
			return drivenBy
				.split( "," )
				.map( x => x.trim() )
				.filter( x => !!x );
		},
	},
};
</script>

<style lang="scss" scoped></style>
